import { render, staticRenderFns } from "./goods-sort.vue?vue&type=template&id=33d77e76&scoped=true&"
import script from "./goods-sort.vue?vue&type=script&lang=js&"
export * from "./goods-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d77e76",
  null
  
)

export default component.exports